import Swup from 'swup'
import SwupPreloadPlugin from '@swup/preload-plugin'

let instance: Swup | null = null

export function getSwup() {
	return instance
}

export function setupSwup() {
	instance = new Swup({
		containers: ['#page'],
		plugins: [new SwupPreloadPlugin()],
	} as any)

	// Keep window.swup for blog.js which uses window.swup.navigate() directly
	window.swup = instance
}
